export const ClickThroughAttributionOptions = {
    1: '1 Day',
    7: '7 Days',
}

export const ViewThroughAttributionOptions = {
    0: "None",
    1: '1 Day',
}